<template>
  <div class="form-check form-switch form-switch-xl">
    <input class="form-check-input" :class="{'form-switch-readonly': readonly}" type="checkbox"
           :checked="checked" @change="$emit('update:checked', $event.target.checked)"
    >
  </div>
</template>

<script>
export default {
  name: "SwitchInput",
  emits: ['update:checked'],
  props: {
    checked: {
      type: [Boolean, null],
      required: true
    },
    readonly: {
      type: Boolean,
      default: false,
    }
  },
}
</script>

<style scoped>
input[type="checkbox"].form-switch-readonly {
  pointer-events: none;
}
</style>
